module.exports = __webpack_public_path__ + "static/media/step03.319c12b5.svg";